'use es6';

import { Map as ImmutableMap } from 'immutable';
export default ImmutableMap({
  privacy_consent_approve: {
    id: 'privacy_consent_approve',
    label: 'customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.approve'
  },
  privacy_consent_decline: {
    id: 'privacy_consent_decline',
    label: 'customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.decline'
  },
  privacy_consent_revoke: {
    id: 'privacy_consent_revoke',
    label: 'customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.revoke'
  }
});